'use strict';

var Option$BsBastet = require("bs-bastet/bastet/src/Option.bs.js");
var Relude_Option_Base = require("./option/Relude_Option_Base.bs.js");
var Relude_Extensions_Alt = require("./extensions/Relude_Extensions_Alt.bs.js");
var Relude_Extensions_Apply = require("./extensions/Relude_Extensions_Apply.bs.js");
var Relude_Extensions_Monad = require("./extensions/Relude_Extensions_Monad.bs.js");
var Relude_Option_Instances = require("./option/Relude_Option_Instances.bs.js");
var Relude_Extensions_Functor = require("./extensions/Relude_Extensions_Functor.bs.js");
var Relude_Option_Specializations = require("./option/Relude_Option_Specializations.bs.js");
var Relude_Extensions_Semigroupoid = require("./extensions/Relude_Extensions_Semigroupoid.bs.js");

var include = Relude_Extensions_Semigroupoid.SemigroupoidInfix(Relude_Option_Instances.Semigroupoid);

var include$1 = Relude_Extensions_Functor.FunctorInfix(Relude_Option_Instances.Functor);

var include$2 = Relude_Extensions_Alt.AltInfix(Option$BsBastet.Alt);

var include$3 = Relude_Extensions_Apply.ApplyInfix(Relude_Option_Instances.Apply);

var include$4 = Relude_Extensions_Monad.MonadInfix(Relude_Option_Instances.Monad);

function $pipe$question(opt, $$default) {
  return Relude_Option_Base.getOrElse($$default, opt);
}

var Infix_SE = include.SE;

var Infix_$less$less$less = include.$less$less$less;

var Infix_$great$great$great = include.$great$great$great;

var Infix_FunctorExtensions = include$1.FunctorExtensions;

var Infix_$less$dollar$great = include$1.$less$$great;

var Infix_$less$hash$great = include$1.$less$hash$great;

var Infix_$less$dollar = include$1.$less$;

var Infix_$$great = include$1.$$great;

var Infix_$less$at$great = include$1.$less$at$great;

var Infix_$less$pipe$great = include$2.$less$pipe$great;

var Infix_ApplyExtensions = include$3.ApplyExtensions;

var Infix_$less$star$great = include$3.$less$star$great;

var Infix_$less$star = include$3.$less$star;

var Infix_$star$great = include$3.$star$great;

var Infix_MonadExtensions = include$4.MonadExtensions;

var Infix_$great$great$eq = include$4.$great$great$eq;

var Infix_$eq$less$less = include$4.$eq$less$less;

var Infix_$great$eq$great = include$4.$great$eq$great;

var Infix_$less$eq$less = include$4.$less$eq$less;

var Infix = {
  SE: Infix_SE,
  $less$less$less: Infix_$less$less$less,
  $great$great$great: Infix_$great$great$great,
  FunctorExtensions: Infix_FunctorExtensions,
  $less$$great: Infix_$less$dollar$great,
  $less$hash$great: Infix_$less$hash$great,
  $less$: Infix_$less$dollar,
  $$great: Infix_$$great,
  $less$at$great: Infix_$less$at$great,
  $less$pipe$great: Infix_$less$pipe$great,
  ApplyExtensions: Infix_ApplyExtensions,
  $less$star$great: Infix_$less$star$great,
  $less$star: Infix_$less$star,
  $star$great: Infix_$star$great,
  MonadExtensions: Infix_MonadExtensions,
  $great$great$eq: Infix_$great$great$eq,
  $eq$less$less: Infix_$eq$less$less,
  $great$eq$great: Infix_$great$eq$great,
  $less$eq$less: Infix_$less$eq$less,
  $pipe$question: $pipe$question
};

var compose = Relude_Option_Instances.compose;

var Semigroupoid = Relude_Option_Instances.Semigroupoid;

var andThen = Relude_Option_Instances.andThen;

var map = Relude_Option_Instances.map;

var Functor = Relude_Option_Instances.Functor;

var BsFunctorExtensions = Relude_Option_Instances.BsFunctorExtensions;

var flipMap = Relude_Option_Instances.flipMap;

var $$void = Relude_Option_Instances.$$void;

var voidRight = Relude_Option_Instances.voidRight;

var voidLeft = Relude_Option_Instances.voidLeft;

var flap = Relude_Option_Instances.flap;

var apply = Relude_Option_Instances.apply;

var Apply = Relude_Option_Instances.Apply;

var BsApplyExtensions = Relude_Option_Instances.BsApplyExtensions;

var applyFirst = Relude_Option_Instances.applyFirst;

var applySecond = Relude_Option_Instances.applySecond;

var map2 = Relude_Option_Instances.map2;

var map3 = Relude_Option_Instances.map3;

var map4 = Relude_Option_Instances.map4;

var map5 = Relude_Option_Instances.map5;

var tuple2 = Relude_Option_Instances.tuple2;

var tuple3 = Relude_Option_Instances.tuple3;

var tuple4 = Relude_Option_Instances.tuple4;

var tuple5 = Relude_Option_Instances.tuple5;

var mapTuple2 = Relude_Option_Instances.mapTuple2;

var mapTuple3 = Relude_Option_Instances.mapTuple3;

var mapTuple4 = Relude_Option_Instances.mapTuple4;

var mapTuple5 = Relude_Option_Instances.mapTuple5;

var pure = Relude_Option_Instances.pure;

var Applicative = Relude_Option_Instances.Applicative;

var BsApplicativeExtensions = Relude_Option_Instances.BsApplicativeExtensions;

var liftA1 = Relude_Option_Instances.liftA1;

var bind = Relude_Option_Instances.bind;

var Monad = Relude_Option_Instances.Monad;

var BsMonadExtensions = Relude_Option_Instances.BsMonadExtensions;

var flatMap = Relude_Option_Instances.flatMap;

var flatten = Relude_Option_Instances.flatten;

var composeKleisli = Relude_Option_Instances.composeKleisli;

var flipComposeKleisli = Relude_Option_Instances.flipComposeKleisli;

var liftM1 = Relude_Option_Instances.liftM1;

var when_ = Relude_Option_Instances.when_;

var unless = Relude_Option_Instances.unless;

var align = Relude_Option_Instances.align;

var alignWith = Relude_Option_Instances.alignWith;

var Semialign = Relude_Option_Instances.Semialign;

var Align = Relude_Option_Instances.Align;

var foldLeft = Relude_Option_Instances.foldLeft;

var foldRight = Relude_Option_Instances.foldRight;

var Foldable = Relude_Option_Instances.Foldable;

var BsFoldableExtensions = Relude_Option_Instances.BsFoldableExtensions;

var any = Relude_Option_Instances.any;

var all = Relude_Option_Instances.all;

var containsBy = Relude_Option_Instances.containsBy;

var contains = Relude_Option_Instances.contains;

var indexOfBy = Relude_Option_Instances.indexOfBy;

var indexOf = Relude_Option_Instances.indexOf;

var minBy = Relude_Option_Instances.minBy;

var min = Relude_Option_Instances.min;

var maxBy = Relude_Option_Instances.maxBy;

var max = Relude_Option_Instances.max;

var countBy = Relude_Option_Instances.countBy;

var length = Relude_Option_Instances.length;

var size = Relude_Option_Instances.size;

var count = Relude_Option_Instances.count;

var forEach = Relude_Option_Instances.forEach;

var forEachWithIndex = Relude_Option_Instances.forEachWithIndex;

var find = Relude_Option_Instances.find;

var findWithIndex = Relude_Option_Instances.findWithIndex;

var toList = Relude_Option_Instances.toList;

var toArray = Relude_Option_Instances.toArray;

var FoldableSemigroupExtensions = Relude_Option_Instances.FoldableSemigroupExtensions;

var FoldableMonoidExtensions = Relude_Option_Instances.FoldableMonoidExtensions;

var foldMap = Relude_Option_Instances.foldMap;

var foldWithMonoid = Relude_Option_Instances.foldWithMonoid;

var intercalate = Relude_Option_Instances.intercalate;

var FoldableApplicativeExtensions = Relude_Option_Instances.FoldableApplicativeExtensions;

var FoldableMonadExtensions = Relude_Option_Instances.FoldableMonadExtensions;

var FoldableEqExtensions = Relude_Option_Instances.FoldableEqExtensions;

var FoldableOrdExtensions = Relude_Option_Instances.FoldableOrdExtensions;

var alt = Relude_Option_Instances.alt;

var altLazy = Relude_Option_Instances.altLazy;

var Semigroup_Any = Relude_Option_Instances.Semigroup_Any;

var Monoid_Any = Relude_Option_Instances.Monoid_Any;

var Alt = Relude_Option_Instances.Alt;

var Plus = Relude_Option_Instances.Plus;

var Alternative = Relude_Option_Instances.Alternative;

var Traversable = Relude_Option_Instances.Traversable;

var eqBy = Relude_Option_Instances.eqBy;

var eq = Relude_Option_Instances.eq;

var Eq = Relude_Option_Instances.Eq;

var Ord = Relude_Option_Instances.Ord;

var showBy = Relude_Option_Instances.showBy;

var show = Relude_Option_Instances.show;

var Show = Relude_Option_Instances.Show;

var WithSemigroup = Relude_Option_Instances.WithSemigroup;

var WithApplicative = Relude_Option_Instances.WithApplicative;

var some = Relude_Option_Base.some;

var none;

var empty;

var isSome = Relude_Option_Base.isSome;

var isNone = Relude_Option_Base.isNone;

var fold = Relude_Option_Base.fold;

var foldLazy = Relude_Option_Base.foldLazy;

var getOrElse = Relude_Option_Base.getOrElse;

var getOrElseLazy = Relude_Option_Base.getOrElseLazy;

var getOrThrow = Relude_Option_Base.getOrThrow;

var orElse = Relude_Option_Base.orElse;

var orElseLazy = Relude_Option_Base.orElseLazy;

var tap = Relude_Option_Base.tap;

var tapSome = Relude_Option_Base.tapSome;

var tapNone = Relude_Option_Base.tapNone;

var bitap = Relude_Option_Base.bitap;

var filter = Relude_Option_Base.filter;

var keep = Relude_Option_Base.keep;

var filterNot = Relude_Option_Base.filterNot;

var reject = Relude_Option_Base.reject;

var OptionEqExtensions = Relude_Option_Specializations.OptionEqExtensions;

var OptionOrdExtensions = Relude_Option_Specializations.OptionOrdExtensions;

var $$String = Relude_Option_Specializations.$$String;

var Int = Relude_Option_Specializations.Int;

var Float = Relude_Option_Specializations.Float;

var IO = Relude_Option_Specializations.IO;

exports.compose = compose;
exports.Semigroupoid = Semigroupoid;
exports.andThen = andThen;
exports.map = map;
exports.Functor = Functor;
exports.BsFunctorExtensions = BsFunctorExtensions;
exports.flipMap = flipMap;
exports.$$void = $$void;
exports.voidRight = voidRight;
exports.voidLeft = voidLeft;
exports.flap = flap;
exports.apply = apply;
exports.Apply = Apply;
exports.BsApplyExtensions = BsApplyExtensions;
exports.applyFirst = applyFirst;
exports.applySecond = applySecond;
exports.map2 = map2;
exports.map3 = map3;
exports.map4 = map4;
exports.map5 = map5;
exports.tuple2 = tuple2;
exports.tuple3 = tuple3;
exports.tuple4 = tuple4;
exports.tuple5 = tuple5;
exports.mapTuple2 = mapTuple2;
exports.mapTuple3 = mapTuple3;
exports.mapTuple4 = mapTuple4;
exports.mapTuple5 = mapTuple5;
exports.pure = pure;
exports.Applicative = Applicative;
exports.BsApplicativeExtensions = BsApplicativeExtensions;
exports.liftA1 = liftA1;
exports.bind = bind;
exports.Monad = Monad;
exports.BsMonadExtensions = BsMonadExtensions;
exports.flatMap = flatMap;
exports.flatten = flatten;
exports.composeKleisli = composeKleisli;
exports.flipComposeKleisli = flipComposeKleisli;
exports.liftM1 = liftM1;
exports.when_ = when_;
exports.unless = unless;
exports.align = align;
exports.alignWith = alignWith;
exports.Semialign = Semialign;
exports.Align = Align;
exports.foldLeft = foldLeft;
exports.foldRight = foldRight;
exports.Foldable = Foldable;
exports.BsFoldableExtensions = BsFoldableExtensions;
exports.any = any;
exports.all = all;
exports.containsBy = containsBy;
exports.contains = contains;
exports.indexOfBy = indexOfBy;
exports.indexOf = indexOf;
exports.minBy = minBy;
exports.min = min;
exports.maxBy = maxBy;
exports.max = max;
exports.countBy = countBy;
exports.length = length;
exports.size = size;
exports.count = count;
exports.forEach = forEach;
exports.forEachWithIndex = forEachWithIndex;
exports.find = find;
exports.findWithIndex = findWithIndex;
exports.toList = toList;
exports.toArray = toArray;
exports.FoldableSemigroupExtensions = FoldableSemigroupExtensions;
exports.FoldableMonoidExtensions = FoldableMonoidExtensions;
exports.foldMap = foldMap;
exports.foldWithMonoid = foldWithMonoid;
exports.intercalate = intercalate;
exports.FoldableApplicativeExtensions = FoldableApplicativeExtensions;
exports.FoldableMonadExtensions = FoldableMonadExtensions;
exports.FoldableEqExtensions = FoldableEqExtensions;
exports.FoldableOrdExtensions = FoldableOrdExtensions;
exports.alt = alt;
exports.altLazy = altLazy;
exports.Semigroup_Any = Semigroup_Any;
exports.Monoid_Any = Monoid_Any;
exports.Alt = Alt;
exports.Plus = Plus;
exports.Alternative = Alternative;
exports.Traversable = Traversable;
exports.eqBy = eqBy;
exports.eq = eq;
exports.Eq = Eq;
exports.Ord = Ord;
exports.showBy = showBy;
exports.show = show;
exports.Show = Show;
exports.WithSemigroup = WithSemigroup;
exports.WithApplicative = WithApplicative;
exports.some = some;
exports.none = none;
exports.empty = empty;
exports.isSome = isSome;
exports.isNone = isNone;
exports.fold = fold;
exports.foldLazy = foldLazy;
exports.getOrElse = getOrElse;
exports.getOrElseLazy = getOrElseLazy;
exports.getOrThrow = getOrThrow;
exports.orElse = orElse;
exports.orElseLazy = orElseLazy;
exports.tap = tap;
exports.tapSome = tapSome;
exports.tapNone = tapNone;
exports.bitap = bitap;
exports.filter = filter;
exports.keep = keep;
exports.filterNot = filterNot;
exports.reject = reject;
exports.OptionEqExtensions = OptionEqExtensions;
exports.OptionOrdExtensions = OptionOrdExtensions;
exports.$$String = $$String;
exports.Int = Int;
exports.Float = Float;
exports.IO = IO;
exports.Infix = Infix;
/* include Not a pure module */
